import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserAllSubscriptions } from "../services/user.services";
import { SELECTED_TEAM } from "../redux/actions/teamActions";
import { useHistory } from "react-router-dom";
import { SELECT_INVITE_SUCCESS } from "../redux/actions/userActions";
// import mainImg from "../assets/dashboard.png";
// import "./selectTeam.css";

const SelectAccount = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [teamData, setTeamData] = useState(null);
    const [loading, setLoading] = useState(false);

    const user = useSelector((state) => state.auth.user);
    const invitations = useSelector(state => state.userCreate.invitations)

    const navigateToCreateTeam = () => {
        history.push("/createteam");
    };

    const handleSelectAccount = useCallback((invite) => {
        dispatch({ type: SELECT_INVITE_SUCCESS, payload: invite })
        history.push("/selectteam")
    }, []);
    // const handleLogout = () => {
    //     history.push("/auth-navigator");
    //     dispatch({ type: "LOGOUT" });
    // };

    return (
        <div className="mainBackground">
            {/* <div className="imageBox">
        <img src={mainImg} className="headerImage" />
      </div> */}
            <h1 className="title">SELECT ACCOUNT TO CONTINUE</h1>

            <div className="teamsButton">
                <div className="teamsMain">
                    <div className="featuredContainer">
                        {loading ? (
                            <p style={{ color: "white" }}>Loading...</p>
                        ) : (
                            <div className="allTeams">
                                {invitations && invitations.length > 0 ? (
                                    invitations.map((inv) => (
                                        <div
                                            key={inv._id}
                                            className="teamContainer"
                                            onClick={() => handleSelectAccount(inv)}
                                        >
                                            <span className="allTeamName">{inv.ownerEmail} </span>
                                            <span style={{ color: "white" }} className="arrow">
                                                {"\u2192"}
                                            </span>
                                        </div>
                                    ))
                                ) : (
                                    <p style={{ color: "white" }}>No invitations found</p>
                                )}

                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectAccount;
